module.exports = ".alert {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/alert.component.scss
// module id = ./src/app/_directives/alert.component.scss
// module chunks = main